import React from "react"

const Billing = ({ formData, setFormData }) => {
  return (
    <div className="billing checkout-form__form">
      <div className="checkout-form-count">1</div>
      <h1 className="title-md">Billing</h1>
      <div className="input-box">
        <label htmlFor="fullName">Full Name</label>
        <input
          type="text"
          name="fullName"
          id="fullName"
          required
          value={formData?.fullName}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              [e.target.name]: e.target.value,
            }))
          }
        />
      </div>
      <div className="input-box">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          id="email"
          required
          value={formData?.email}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              [e.target.name]: e.target.value,
            }))
          }
        />
      </div>
      <div className="input-box">
        <label htmlFor="mobile">Mobile Phone</label>
        <input
          type="tel"
          name="mobile"
          id="mobile"
          required
          value={formData?.mobile}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              [e.target.name]: e.target.value,
            }))
          }
        />
      </div>
      <div className="input-flex-box">
        <div className="input-box f-grow">
          <label htmlFor="address">Street Address</label>
          <input
            type="text"
            name="address"
            id="address"
            required
            value={formData?.address}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
        <div className="input-box">
          <label htmlFor="suite">Suite (optional)</label>
          <input
            className="number-input"
            type="text"
            name="suite"
            id="suite"
            value={formData?.suite}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
      </div>
      <div className="input-box">
        <label htmlFor="city">City</label>
        <input
          type="text"
          name="city"
          id="city"
          value={formData?.city}
          required
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              [e.target.name]: e.target.value,
            }))
          }
        />
      </div>
      <div className="input-box">
        <label htmlFor="country">Country</label>
        <input
          readOnly
          type="text"
          name="country"
          id="country"
          value={formData?.country}
        />
      </div>
      <div className="input-flex-box">
        <div className="input-box f-grow">
          <label htmlFor="state">State</label>
          <input
            type="text"
            name="state"
            id="state"
            required
            value={formData?.state}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
        <div className="input-box">
          <label htmlFor="zipCode">Postal / ZIP code</label>
          <input
            className="number-input"
            type="number"
            name="zipCode"
            id="zipCode"
            required
            value={formData?.zipCode}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
      </div>
      {/* <button className="btn-cta danger c-btn">Continue to shipping</button> */}
    </div>
  )
}

export default Billing
